// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.system-log__pagination .sk-pagination__mobile-wrapper {\n  margin: 0 0 0 -65px;\n}\n", ""]);
// Exports
module.exports = exports;
